module.exports = __webpack_public_path__ + "static/media/karolina-andrade.3b7d72ff.png";